import { useQuery } from '@tanstack/react-query';
import { getLanguagesOptions } from '@/client/@tanstack/react-query.gen';
import { getTransify } from '@/client/sdk.gen';
import { useStore } from '@/store';
import { LANGUAGE_STORAGE_KEY } from '@/lib/i18n';
import type { GetLanguagesResponse } from '@/client/types.gen';

// Re-export the language type for convenience
export type LanguageItem = GetLanguagesResponse[number];

// Hook to fetch available languages
export function useLanguagesQuery() {
  return useQuery({
    ...getLanguagesOptions(),
  });
}

// Fetch translation data from API and apply to store + i18n
export async function fetchAndApplyTranslation(lang: string): Promise<void> {
  const { translation, setTranslation, setLanguage } = useStore.getState();

  // Skip fetch if already cached in store
  if (translation[lang] && Object.keys(translation[lang]).length > 0) {
    setLanguage(lang);
    persistLanguage(lang);
    return;
  }

  const { data } = await getTransify({
    query: { lang },
    throwOnError: true,
  });

  if (data) {
    setTranslation(lang, data);
  }

  setLanguage(lang);
  persistLanguage(lang);
}

// Persist language choice to localStorage
function persistLanguage(lang: string): void {
  try {
    localStorage.setItem(LANGUAGE_STORAGE_KEY, lang);
  } catch {
    // Ignore localStorage errors (e.g. private browsing)
  }
}
